import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Autosuggest from 'react-autosuggest';
import './styles.scss';

const getSuggestions = (value, items = []) => {
	const inputValue = value.trim().toLowerCase();
	return inputValue.length === 0
		? items
		: items.filter(
			item =>
				item.label.toLowerCase().slice(0, inputValue.length) === inputValue
		  );
};
const getSuggestionValue = suggestion => suggestion.value;
const renderSuggestion = suggestion => (
	<div key={suggestion.value}>{suggestion.label}</div>
);

class InputAutocomplete extends Component {
	constructor(props) {
		super(props);
		this.state = {
			name: '',
			value: '',
			items: [],
			suggestions: []
		};
		this.onChange = this.onChange.bind(this);
		this.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested.bind(
			this
		);
		this.onSuggestionsClearRequested = this.onSuggestionsClearRequested.bind(
			this
		);
		this.onSuggestionSelected = this.onSuggestionSelected.bind(this);
		this.renderSuggestionsContainer = this.renderSuggestionsContainer.bind(
			this
		);
	}
	componentDidMount() {
		this.setState({
			name: this.props.name
		});
	}
	onChange(event, { newValue }) {
		const { name } = this.state;
		this.props.changed(newValue, name);
	}
	componentWillReceiveProps(nextProps) {
		if (this.props.items !== nextProps.items) {
			this.setState({ items: nextProps.items });
		}

		if (this.props.name !== nextProps.name) {
			this.setState({ name: nextProps.name });
		}
	}
	onSuggestionsFetchRequested({ value }) {
		const { items } = this.state;
		this.setState({
			suggestions: getSuggestions(value, items)
		});
	}
	onSuggestionSelected(event, { suggestion }) {
		this.props.itemSelected(suggestion, this.state.name);
	}
	onSuggestionsClearRequested() {
		this.setState({
			suggestions: []
		});
	}
	renderSuggestionsContainer({ containerProps, children }) {
		const { footer } = this.props;
		return (
			<div {...containerProps}>
				{children}
				{footer}
			</div>
		);
	}
	render() {
		const { suggestions } = this.state;
		const { placeholder, value, styles, footer } = this.props;
		const inputProps = {
			value,
			onChange: this.onChange,
			placeholder
		};
		return (
			<div
				className={`InputAutocomplete ${
					footer ? 'InputAutocomplete-footer-present' : ''
				}`}
				style={styles}
			>
				<Autosuggest
					onClick={() => console.log('clicked')}
					alwaysRenderSuggestions={true}
					suggestions={suggestions}
					onSuggestionSelected={this.onSuggestionSelected}
					onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
					onSuggestionsClearRequested={this.onSuggestionsClearRequested}
					renderSuggestionsContainer={this.renderSuggestionsContainer}
					getSuggestionValue={getSuggestionValue}
					renderSuggestion={renderSuggestion}
					inputProps={inputProps}
				/>
			</div>
		);
	}
}

InputAutocomplete.propTypes = {
	styles: PropTypes.object,
	items: PropTypes.arrayOf(PropTypes.object),
	placeholder: PropTypes.string,
	value: PropTypes.string,
	name: PropTypes.string,
	changed: PropTypes.func,
	itemSelected: PropTypes.func
};

InputAutocomplete.defaultProps = {
	items: [],
	placeholder: 'Select...',
	value: ''
};

export default InputAutocomplete;
